// extracted by mini-css-extract-plugin
export default {"medium":"only screen and (min-width: 768px)","cardWrapper":"wrfEV _1bL04 _2_DZ4 _30NYb eybWJ _1i_4K _3nse8","hideOnTabletPortraitAndUp":"_3zpCM"};